import { useNavigate } from 'react-router-dom';

import { mapCompleteProfileToBasicProfileEventPayload } from '../mappers';
import { isStageAlreadyExistsError } from '../utils/leadEventError';
import { useLeadEventsCache } from './useLeadEventsCache';
import { usePostLeadEvent } from './usePostLeadEvent';
import { getOnboardingResumePath } from '../../utils/onboardingResumePath';

export function useCompleteProfileSubmit() {
  const navigate = useNavigate();
  const { refetchLeadEvents, getCachedLeadEvents } = useLeadEventsCache();
  const postBasicProfile = usePostLeadEvent({
    invalidateEventsOnSuccess: false,
    mergeEventIntoCacheOnSuccess: false,
  });

  const submit = async (data) => {
    const payload = mapCompleteProfileToBasicProfileEventPayload(data);

    try {
      await postBasicProfile.mutateAsync(payload);
      await refetchLeadEvents();
      navigate('../training');
    } catch (error) {
      if (isStageAlreadyExistsError(error)) {
        await refetchLeadEvents();
        navigate(getOnboardingResumePath(getCachedLeadEvents()), {
          replace: true,
        });
      }
    }
  };

  return {
    submit,
    isPending: postBasicProfile.isPending,
    isSuccess: postBasicProfile.isSuccess,
  };
}
